import { __decorate } from "tslib";
import { customElement, FASTElement, html } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../../common/ChameleonElement';
import styles from './MenuSection.styles.scss';
const template = html `<chameleon-typography
  variant="caption-medium-strong"
  color="type-color-secondary"
  ><slot></slot
></chameleon-typography>`;
export const menuSectionDefinition = {
    name: 'chameleon-menu-section',
    template,
    styles,
};
let MenuSectionComponent = class MenuSectionComponent extends ChameleonElementMixin(FASTElement) {
};
MenuSectionComponent = __decorate([
    customElement(menuSectionDefinition)
], MenuSectionComponent);
export { MenuSectionComponent };
